import axios from "axios";

const BASE_URL = process.env.REACT_APP_BACKEND + "dashboard";

/**
 * 上傳儀表板媒體檔案
 * @param {File[]} files - 檔案陣列
 * @param {string} mediaType - 媒體類型 ('image' 或 'video')
 * @returns {Promise<Object>} 上傳結果
 */
export const uploadDashboardMedia = async (files, mediaType = 'image') => {
  const formData = new FormData();
  
  files.forEach(file => {
    formData.append('files', file);
  });
  formData.append('media_type', mediaType);
  
  try {
    const response = await axios.post(`${BASE_URL}/media/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  } catch (error) {
    console.error('上傳媒體檔案失敗:', error);
    throw error;
  }
};

/**
 * 刪除儀表板媒體檔案
 * @param {string} filename - 檔案名稱
 * @returns {Promise<Object>} 刪除結果
 */
export const deleteDashboardMedia = async (filename) => {
  try {
    const response = await axios.post(`${BASE_URL}/media/delete`, { filename });
    return response.data.data;
  } catch (error) {
    console.error('刪除媒體檔案失敗:', error);
    throw error;
  }
};
